import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { List } from 'immutable'

import { getUsers } from 'data/users/selectors'

import { UserAvatar } from 'components/Utils/Avatar'
import { CloseIcon } from 'components/Utils/Icons'
import { Name } from 'components/base/Text'

class SearchBar extends Component {
  static propTypes = {
    onSearch: PropTypes.func.isRequired,
    autoFocus: PropTypes.bool,
    users: PropTypes.instanceOf(List).isRequired,
    removeUserId: PropTypes.func.isRequired,
    searchTerm: PropTypes.string.isRequired,
  }

  static defaultProps = {
    autoFocus: true,
  }

  onInputChange = e => this.props.onSearch(e.target.value)

  onInputKeyDown = e => {
    const { users, removeUserId } = this.props
    if (
      this.props.searchTerm.length === 0 &&
      e.keyCode === 8 /* Backspace */ &&
      users.last()
    ) {
      removeUserId(users.last().id)
    }
  }

  focusInput = () => this.input.focus()

  render() {
    const { users, removeUserId, autoFocus } = this.props
    return (
      <div
        className="width-full radius-top-normal background-shade-100 border-small border-shade-30 padding-normal flexbox flexbox-wrap"
        onClick={this.focusInput}
      >
        {users.map(user => (
          <div
            key={user.id}
            className="flexbox flexbox-justify-center flexbox-align-center padding-smaller background-shade-50 radius-largest margin-right-normal"
            style={{ height: 30 }}
          >
            <UserAvatar
              className="border-none"
              userId={user.get('id')}
              size="small"
            />

            <Name className="margin-horizontal-small">@{user.username}</Name>

            <div
              className="shade-30 shade-20-on-hover pointer padding-right-small"
              style={{ marginBottom: 3 }}
              onClick={() => removeUserId(user.id)}
            >
              <CloseIcon size={10} />
            </div>
          </div>
        ))}
        <input
          className="no-outline border-none font-size-small shade-10"
          style={{ minWidth: 200, height: 30, lineHeight: 30 }}
          placeholder="Search for team members"
          type="text"
          onChange={this.onInputChange}
          onKeyDown={this.onInputKeyDown}
          autoFocus={autoFocus}
          tabIndex="-1"
          ref={ref => {
            this.input = ref
          }}
          value={this.props.searchTerm}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, { userIds }) => ({
  users: getUsers(state, userIds).toList(),
})

export default connect(mapStateToProps)(SearchBar)
